import React from 'react';
import './TopBar.css';

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="container">
        <div className="topbar-left">
          <span className="topbar-item">
            <span>📍</span>
            <span>2033 Dodge Ave, Evanston, IL 60201</span>
          </span>
          <span className="topbar-item">
            <span>📞</span>
            <a href="tel:+12244154202">224-415-4202</a>
          </span>
          <span className="topbar-item">
            <span>📧</span>
            <a href="mailto:info@amobiletax.com">info@amobiletax.com</a>
          </span>
        </div>
        <div className="topbar-right">
          <span className="topbar-item">
            <span>🕐</span>
            <span>Mon–Sat: 9AM–7PM</span>
          </span>
          <a href="https://wa.me/12244154202" target="_blank" rel="noreferrer" className="topbar-wa">
            💬 WhatsApp Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
